import { render, staticRenderFns } from "./service_mobile.vue?vue&type=template&id=be8b48f8&scoped=true"
import script from "./service_mobile.vue?vue&type=script&lang=js"
export * from "./service_mobile.vue?vue&type=script&lang=js"
import style0 from "./service_mobile.vue?vue&type=style&index=0&id=be8b48f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8b48f8",
  null
  
)

export default component.exports